/* tslint:disable */
export class LocaleKeys {
    constructor(private translate: Function) {
        //
    }

    public THANK_YOU_MSG = (options: { username: any }) => this.translate('THANK_YOU_MSG', options) /* THANKS FOR SHOPPING, {{username}}! */;
    public THANK_YOU_MSG_WITHOUT_NAME = () => this.translate('THANK_YOU_MSG_WITHOUT_NAME') /* THANKS FOR SHOPPING! */;
    public LIKE_YOUR_STYLE_TITLE = () => this.translate('LIKE_YOUR_STYLE_TITLE') /* HOPE TO SEE YOU AGAIN SOON. */;
    public SUMMARY_TITLE = () => this.translate('SUMMARY_TITLE') /* SUMMARY */;
    public ORDER_NUMBER_TITLE = () => this.translate('ORDER_NUMBER_TITLE') /* Your order number: */;
    public TOTAL_COST_TITLE = () => this.translate('TOTAL_COST_TITLE') /* Total cost: */;
    public SHIPPING_TO_TITLE = () => this.translate('SHIPPING_TO_TITLE') /* Delivery to: */;
    public SEND_EMAIL_TEXT = () => this.translate('SEND_EMAIL_TEXT') /*   */;
    public CONTINUE_SHOPPING_BUTTON = () => this.translate('CONTINUE_SHOPPING_BUTTON') /* Continue Shopping */;
    public SHIPPING_TO = (options: { city: any, state: any, zipCode: any, country: any }) => this.translate('SHIPPING_TO', options) /* {{city}}, {{state}} {{zipCode}}, {{country}} */;
    public thankYou = {
        TITLE: () => this.translate('thankYou.TITLE') /* Thank you for your order. */,
        TITLE_WITH_NAME: (options: { fullName: any }) => this.translate('thankYou.TITLE_WITH_NAME', options) /* Thank you for your order, {{fullName}}. */,
        SUBTITLE: () => this.translate('thankYou.SUBTITLE') /* You'll receive an email confirmation soon. */,
        ORDER_NUMBER_LABEL: () => this.translate('thankYou.ORDER_NUMBER_LABEL') /* Order No: */,
        TOTAL_LABEL: () => this.translate('thankYou.TOTAL_LABEL') /* Total: */,
        OFFLINE_PAYMENT_LABEL: () => this.translate('thankYou.OFFLINE_PAYMENT_LABEL') /* Offline Payment */,
        STORE_PICKUP_LABEL: () => this.translate('thankYou.STORE_PICKUP_LABEL') /* Pickup */,
        STORE_PICKUP_TIME: (options: { deliveryTime: any }) => this.translate('thankYou.STORE_PICKUP_TIME', options) /* Ready for pickup: {{deliveryTime}} */,
        SHIPPING_LABEL: () => this.translate('thankYou.SHIPPING_LABEL') /* Delivery to: */,
        DELIVERY_ADDRESS: (options: { addressLine: any, city: any, state: any, zipCode: any, country: any }) => this.translate('thankYou.DELIVERY_ADDRESS', options) /* {{addressLine}}
{{city}}, {{state}} {{zipCode}}
{{country}} */,
        DELIVERY_ADDRESS_FULL: (options: { fullName: any, company: any, addressLine: any, city: any, state: any, zipCode: any, country: any, phone: any }) => this.translate('thankYou.DELIVERY_ADDRESS_FULL', options) /* {{fullName}}
{{company}}
{{addressLine}}
{{city}}, {{state}} {{zipCode}}
{{country}}
{{phone}} */,
        DELIVERY_ADDRESS_FULL_INCLUDING_ADDRESS_LINE_2: (options: { fullName: any, company: any, addressLine: any, addressLine2: any, city: any, state: any, zipCode: any, country: any, phone: any }) => this.translate('thankYou.DELIVERY_ADDRESS_FULL_INCLUDING_ADDRESS_LINE_2', options) /* {{fullName}}
{{company}}
{{addressLine}}, {{addressLine2}}
{{city}}, {{state}} {{zipCode}}
{{country}}
{{phone}} */,
        DOWNLOAD_LINKS_LABEL: () => this.translate('thankYou.DOWNLOAD_LINKS_LABEL') /* Your Downloads: */,
        DOWNLOAD_LINK_LABEL: () => this.translate('thankYou.DOWNLOAD_LINK_LABEL') /* Download */,
        FOOTER_CONFIRMATION_TEXT: () => this.translate('thankYou.FOOTER_CONFIRMATION_TEXT') /* Keep an eye on your inbox - a confirmation email is on its way... */,
        FOOTER_DOWNLOADS_CONFIRMATION_TEXT: () => this.translate('thankYou.FOOTER_DOWNLOADS_CONFIRMATION_TEXT') /* Downloads available for 30 days. And keep an eye on your inbox - we have also sent them by email... */,
        FOOTER_LINK: () => this.translate('thankYou.FOOTER_LINK') /* Continue Shopping */,
        LOADING_TITLE: () => this.translate('thankYou.LOADING_TITLE') /* Processing your payment... */,
        PENDING_ORDER_MESSAGE: (options: { buyerMail: any }) => this.translate('thankYou.PENDING_ORDER_MESSAGE', options) /* Your order is being processed.
We will notify you once it has been approved by email to {{buyerMail}}. */,
        DOWNLOAD_LINKS_ERROR: () => this.translate('thankYou.DOWNLOAD_LINKS_ERROR') /* Download links are currently not available. */,
        DOWNLOAD_LINKS_ERROR_CONTINUED: () => this.translate('thankYou.DOWNLOAD_LINKS_ERROR_CONTINUED') /* You’ll receive an email confirmation soon with the download links to your products. */,
        additionalFees: () => this.translate('thankYou.additionalFees') /* Additional fees:  */,
    };
    public THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_SINGULAR = (options: { frequencyUnitSingular: any }) => this.translate('THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_SINGULAR', options) /* 1 {{frequencyUnitSingular}} subscription */;
    public THANK_YOU_PAGE_SUBSCRIPTION_PLAN_LABEL = () => this.translate('THANK_YOU_PAGE_SUBSCRIPTION_PLAN_LABEL') /* Subscription: */;
    public THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_PLURAL = (options: { numberOfFrequencyUnits: any, frequencyUnitSingular: any }) => this.translate('THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_PLURAL', options) /* {{numberOfFrequencyUnits}} {{frequencyUnitSingular}} subscription */;
    public THANK_YOU_PAGE_SUBSCRIPTION_TITLE = (options: { fullName: any }) => this.translate('THANK_YOU_PAGE_SUBSCRIPTION_TITLE', options) /* Thank you for subscribing, {{fullName}}! */;
    public THANK_YOU_PAGE_PLAN_FREQUENCY_DESCRIPTION = (options: { price: any, frequencyUnitSingular: any }) => this.translate('THANK_YOU_PAGE_PLAN_FREQUENCY_DESCRIPTION', options) /* {{price}} / {{frequencyUnitSingular}} */;
    public THANK_YOU_PAGE_PLAN_MONTHS = () => this.translate('THANK_YOU_PAGE_PLAN_MONTHS') /* month */;
    public THANK_YOU_PAGE_PLAN_YEAR = () => this.translate('THANK_YOU_PAGE_PLAN_YEAR') /* year */;
    public THANK_YOU_PAGE_PLAN_WEEK = () => this.translate('THANK_YOU_PAGE_PLAN_WEEK') /* week */;
    public THANK_YOU_PAGE_PLAN_WEEKS = () => this.translate('THANK_YOU_PAGE_PLAN_WEEKS') /* week */;
    public THANK_YOU_PAGE_PLAN_MONTH = () => this.translate('THANK_YOU_PAGE_PLAN_MONTH') /* month */;
    public THANK_YOU_PAGE_PLAN_YEARS = () => this.translate('THANK_YOU_PAGE_PLAN_YEARS') /* year */;
    public THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_AUTORENEW = () => this.translate('THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_AUTORENEW') /* Auto-renew until canceled */;
    public thankYouPage = {
        shipping: {
            label: () => this.translate('thankYouPage.shipping.label') /* Delivery */,
        },
        paymentMethod: {
            label: () => this.translate('thankYouPage.paymentMethod.label') /* Payment method */,
            multipleMethods: {
                label: (options: { paymentMethod1: any, paymentMethod2: any }) => this.translate('thankYouPage.paymentMethod.multipleMethods.label', options) /* {{paymentMethod1}}, {{paymentMethod2}} */,
            },
        },
        subtitle: {
            orderNumber: () => this.translate('thankYouPage.subtitle.orderNumber') /* Order number:  */,
            orderConfirmation: () => this.translate('thankYouPage.subtitle.orderConfirmation') /* You'll receive a confirmation email soon. */,
        },
        quantity: {
            label: () => this.translate('thankYouPage.quantity.label') /* Qty: */,
        },
        total: {
            label: () => this.translate('thankYouPage.total.label') /* Total */,
        },
        title: {
            withName: (options: { name: any }) => this.translate('thankYouPage.title.withName', options) /* Thank you, {{name}} */,
            withoutName: () => this.translate('thankYouPage.title.withoutName') /* Thank you! */,
        },
        customerNote: {
            previewText: () => this.translate('thankYouPage.customerNote.previewText') /* Your customer's note will show here.  */,
            label: () => this.translate('thankYouPage.customerNote.label') /* Note */,
        },
        giftCard: {
            label: () => this.translate('thankYouPage.giftCard.label') /* Gift card */,
        },
        tax: {
            label: () => this.translate('thankYouPage.tax.label') /* Tax */,
        },
        taxExemption: {
            full: {
                label: (options: { name: any }) => this.translate('thankYouPage.taxExemption.full.label', options) /* {{name}} (Exempt) */,
            },
            partial: {
                label: () => this.translate('thankYouPage.taxExemption.partial.label') /* Tax exemption */,
            },
        },
        billingInfo: {
            label: () => this.translate('thankYouPage.billingInfo.label') /* Billing address */,
        },
        back: {
            footerLink: () => this.translate('thankYouPage.back.footerLink') /* Back */,
        },
        subtotal: {
            label: () => this.translate('thankYouPage.subtotal.label') /* Subtotal */,
        },
        promoCode: {
            label: (options: { couponCode: any }) => this.translate('thankYouPage.promoCode.label', options) /* Promo code: {{couponCode}} */,
        },
        moreServices: {
            footerLink: () => this.translate('thankYouPage.moreServices.footerLink') /* Check Out More Services */,
        },
        errorPage: {
            error: {
                title: () => this.translate('thankYouPage.errorPage.error.title') /* This page can't be accessed */,
                body: () => this.translate('thankYouPage.errorPage.error.body') /* Make sure you’re logged in to the right account, or check the URL and try again. */,
            },
        },
        shippingAddress: {
            label: () => this.translate('thankYouPage.shippingAddress.label') /* Delivery address */,
        },
        pendingOrder: {
            title: {
                withName: (options: { name: any }) => this.translate('thankYouPage.pendingOrder.title.withName', options) /* Thank you, {{name}} */,
            },
            body: (options: { buyerEmail: any }) => this.translate('thankYouPage.pendingOrder.body', options) /* Your order is being processed. We'll send an order confirmation to {{buyerEmail}} if it's approved. */,
        },
        addressFormat: {
            line1: {
                withoutSubdivision: (options: { addressLine1: any, city: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line1.withoutSubdivision', options) /* {{addressLine1}}
{{city}}, {{zipCode}}, {{country}} */,
                withSubdivision: (options: { addressLine1: any, city: any, subdivision: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line1.withSubdivision', options) /* {{addressLine1}}
{{city}}, {{subdivision}} {{zipCode}}, {{country}} */,
            },
            line2: {
                withoutSubdivision: (options: { addressLine1: any, addressLine2: any, city: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line2.withoutSubdivision', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{zipCode}}, {{country}} */,
                withSubdivision: (options: { addressLine1: any, addressLine2: any, city: any, subdivision: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line2.withSubdivision', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{subdivision}} {{zipCode}}, {{country}} */,
            },
        },
        deliveryMethod: {
            free: {
                label: () => this.translate('thankYouPage.deliveryMethod.free.label') /* Free */,
            },
        },
        delivery: {
            label: () => this.translate('thankYouPage.delivery.label') /* Delivery */,
        },
        pickup: {
            label: () => this.translate('thankYouPage.pickup.label') /* Pickup */,
        },
        salesTax: {
            label: () => this.translate('thankYouPage.salesTax.label') /* Sales tax */,
        },
        vat: {
            label: () => this.translate('thankYouPage.vat.label') /* VAT */,
        },
        paid: {
            label: () => this.translate('thankYouPage.paid.label') /* Paid */,
        },
        dueLater: {
            label: () => this.translate('thankYouPage.dueLater.label') /* Due later */,
        },
        taxAmount: {
            defaultText: () => this.translate('thankYouPage.taxAmount.defaultText') /* 0.00 */,
        },
        subtotalAmount: {
            defaultText: () => this.translate('thankYouPage.subtotalAmount.defaultText') /* 10.00 */,
        },
        pickupAddress: {
            label: () => this.translate('thankYouPage.pickupAddress.label') /* Pickup address */,
        },
        productOption1: {
            defaultText: () => this.translate('thankYouPage.productOption1.defaultText') /* Product option 1 */,
        },
        customerName: {
            defaultText: () => this.translate('thankYouPage.customerName.defaultText') /* Customer Name */,
        },
        totalAmount: {
            defaultText: () => this.translate('thankYouPage.totalAmount.defaultText') /* 10.00 */,
        },
        productOption3: {
            defaultText: () => this.translate('thankYouPage.productOption3.defaultText') /* Product option 3 */,
        },
        productPrice: {
            defaultText: () => this.translate('thankYouPage.productPrice.defaultText') /* 10.00 */,
        },
        productName: {
            defaultText: () => this.translate('thankYouPage.productName.defaultText') /* Product Name */,
        },
        productOption2: {
            defaultText: () => this.translate('thankYouPage.productOption2.defaultText') /* Product option 2 */,
        },
        address: {
            defaultText: () => this.translate('thankYouPage.address.defaultText') /* Street, City, State
Zip Code, Country */,
        },
        phoneNumber: {
            defaultText: () => this.translate('thankYouPage.phoneNumber.defaultText') /* Phone number */,
        },
        continueBrowsing: {
            footerLink: () => this.translate('thankYouPage.continueBrowsing.footerLink') /* Continue Browsing */,
        },
        designTab: {
            cardBackgroundlabel: () => this.translate('thankYouPage.designTab.cardBackgroundlabel') /* Cards background opacity & color */,
            pageBackgroundlabel: () => this.translate('thankYouPage.designTab.pageBackgroundlabel') /* Page background opacity & color */,
            pageBackground: () => this.translate('thankYouPage.designTab.pageBackground') /* Page background */,
            itemDetails: () => this.translate('thankYouPage.designTab.itemDetails') /* Item details */,
            cardBackground: () => this.translate('thankYouPage.designTab.cardBackground') /* Cards background */,
            links: () => this.translate('thankYouPage.designTab.links') /* Links */,
            general: {
                headerTextFontColor: () => this.translate('thankYouPage.designTab.general.headerTextFontColor') /* Header Text Font & Color */,
                $value: () => this.translate('thankYouPage.designTab.general') /* General */,
            },
            continueBrowsingLink: {
                $value: () => this.translate('thankYouPage.designTab.continueBrowsingLink') /* Continue Browsing link */,
                continueBrowsingLink: () => this.translate('thankYouPage.designTab.continueBrowsingLink.continueBrowsingLink') /* Continue Browsing Link */,
            },
            orderOverview: () => this.translate('thankYouPage.designTab.orderOverview') /* Order overview */,
            items: {
                items: () => this.translate('thankYouPage.designTab.items.items') /* Items */,
                $value: () => this.translate('thankYouPage.designTab.items') /* Items */,
                totals: () => this.translate('thankYouPage.designTab.items.totals') /* Totals */,
            },
        },
        balanceDue: {
            label: () => this.translate('thankYouPage.balanceDue.label') /* Balance due  */,
        },
        deposit: {
            label: () => this.translate('thankYouPage.deposit.label') /* Deposit  */,
        },
        giftCardDelay: {
            errorMessage: () => this.translate('thankYouPage.giftCardDelay.errorMessage') /* We’re experiencing some delays, so it might take longer than usual to send your gift card. Thank you for your patience. */,
        },
        pricingPlans: {
            frequency: {
                years: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.years.plural') /* years */,
                },
                day: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.day.singular') /* day */,
                },
                month: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.month.singular') /* month */,
                },
                months: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.months.plural') /* months */,
                },
                weeks: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.weeks.plural') /* weeks */,
                },
                year: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.year.singular') /* year */,
                },
                days: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.days.plural') /* days */,
                },
                week: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.week.singular') /* week */,
                },
            },
            startDate: {
                label: (options: { date: any }) => this.translate('thankYouPage.pricingPlans.startDate.label', options) /* Start date: {{date}} */,
            },
            afterFreeTrial: {
                label: () => this.translate('thankYouPage.pricingPlans.afterFreeTrial.label') /* After free trial */,
            },
            freeTrial: {
                label: (options: { number: any, frequency: any }) => this.translate('thankYouPage.pricingPlans.freeTrial.label', options) /* Free trial: {{number}} {{frequency}} */,
            },
            duration: {
                label: (options: { number: any, frequency: any }) => this.translate('thankYouPage.pricingPlans.duration.label', options) /* Duration: {{number}} {{frequency}} */,
                untilCanceled: () => this.translate('thankYouPage.pricingPlans.duration.untilCanceled') /* Until canceled */,
            },
        },
        modifiers: {
            categoryLabel: (options: { categoryName: any }) => this.translate('thankYouPage.modifiers.categoryLabel', options) /* {{categoryName}}: */,
            modifierDetails: {
                quantityAndPrice: (options: { quantity: any, modifierName: any, price: any }) => this.translate('thankYouPage.modifiers.modifierDetails.quantityAndPrice', options) /* {{quantity}}x {{modifierName}} ({{price}}) */,
                quantity: (options: { quantity: any, modifierName: any }) => this.translate('thankYouPage.modifiers.modifierDetails.quantity', options) /* {{quantity}}x {{modifierName}} */,
                price: (options: { modifierName: any, price: any }) => this.translate('thankYouPage.modifiers.modifierDetails.price', options) /* {{modifierName}} ({{price}}) */,
                other: (options: { modifierName: any }) => this.translate('thankYouPage.modifiers.modifierDetails.other', options) /* {{modifierName}} */,
            },
            moreHidden: (options: { count: any }) => this.translate('thankYouPage.modifiers.moreHidden', options) /* and {{count}} more */,
        },
        textTab: {
            subscription: {
                title: {
                    $value: () => this.translate('thankYouPage.textTab.subscription.title') /* Subscription title */,
                    defaultText: () => this.translate('thankYouPage.textTab.subscription.title.defaultText') /* Thanks for subscribing! */,
                },
                subtitle: {
                    $value: () => this.translate('thankYouPage.textTab.subscription.subtitle') /* Subscription subtitle */,
                    defaultText: () => this.translate('thankYouPage.textTab.subscription.subtitle.defaultText') /* You'll receive a confirmation email soon. */,
                },
                subscriptionPlanLabel: {
                    label: () => this.translate('thankYouPage.textTab.subscription.subscriptionPlanLabel.label') /* Subscription label */,
                    defaultText: () => this.translate('thankYouPage.textTab.subscription.subscriptionPlanLabel.defaultText') /* Subscription */,
                },
            },
            paymentMethodDefaultText: () => this.translate('thankYouPage.textTab.paymentMethodDefaultText') /* Payment method */,
            platformizedShippingAddressDefaultText: () => this.translate('thankYouPage.textTab.platformizedShippingAddressDefaultText') /* Delivery address */,
            paymentMethodLabel: () => this.translate('thankYouPage.textTab.paymentMethodLabel') /* Payment method label */,
            platformizedTitleDefaultLabel: () => this.translate('thankYouPage.textTab.platformizedTitleDefaultLabel') /* Thank you! */,
            linkHeader: () => this.translate('thankYouPage.textTab.linkHeader') /* Continue Browsing link */,
            billingAddressLabel: () => this.translate('thankYouPage.textTab.billingAddressLabel') /* Billing address label */,
            billingAddressDefaultText: () => this.translate('thankYouPage.textTab.billingAddressDefaultText') /* Billing address */,
        },
        totals: {
            subscriptions: {
                showMore: () => this.translate('thankYouPage.totals.subscriptions.showMore') /* Show More */,
                showLess: () => this.translate('thankYouPage.totals.subscriptions.showLess') /* Show Less */,
                pricingPlanProjection: (options: { itemName: any, chargesDescription: any }) => this.translate('thankYouPage.totals.subscriptions.pricingPlanProjection', options) /* {{itemName}} - {{chargesDescription}} */,
            },
        },
        settingsTab: {
            orderNumber: {
                selection: () => this.translate('thankYouPage.settingsTab.orderNumber.selection') /* Order Number */,
            },
            image: {
                selection: () => this.translate('thankYouPage.settingsTab.image.selection') /* Image */,
            },
            continueBrowsing: {
                selection: () => this.translate('thankYouPage.settingsTab.continueBrowsing.selection') /* Continue Browsing Link */,
            },
        },
    };
    public thank_you_page_plan_frequency_description_2_years_label = () => this.translate('thank_you_page_plan_frequency_description_2_years_label') /* every 2 years */;
    public thank_you_page_plan_frequency_description_year_singular_label = () => this.translate('thank_you_page_plan_frequency_description_year_singular_label') /* per year */;
    public thank_you_page_plan_frequency_description_months_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_months_plural_label', options) /* every {{numberOfFrequencyUnits}} months */;
    public thank_you_page_plan_frequency_description_month_singular_label = () => this.translate('thank_you_page_plan_frequency_description_month_singular_label') /* per month */;
    public thank_you_page_plan_frequency_description_years_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_years_plural_label', options) /* every {{numberOfFrequencyUnits}} years */;
    public thank_you_page_plan_frequency_description_2_weeks_label = () => this.translate('thank_you_page_plan_frequency_description_2_weeks_label') /* every 2 weeks */;
    public thank_you_page_plan_frequency_description_2_months_label = () => this.translate('thank_you_page_plan_frequency_description_2_months_label') /* every 2 months */;
    public thank_you_page_plan_frequency_description_weeks_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_weeks_plural_label', options) /* every {{numberOfFrequencyUnits}} weeks */;
    public thank_you_page_plan_frequency_description_week_singular_label = () => this.translate('thank_you_page_plan_frequency_description_week_singular_label') /* per week */;
    public thankyouPage = {
        extendedFields: {
            boolean: {
                true: () => this.translate('thankyouPage.extendedFields.boolean.true') /* Yes */,
                false: () => this.translate('thankyouPage.extendedFields.boolean.false') /* No */,
            },
        },
        myCartPaymentMethod: {
            offlinePayment: {
                lineItem: () => this.translate('thankyouPage.myCartPaymentMethod.offlinePayment.lineItem') /* Pay in person */,
            },
            offlinePlan: {
                lineItemWithoutId: () => this.translate('thankyouPage.myCartPaymentMethod.offlinePlan.lineItemWithoutId') /* Pay later with a plan */,
                lineItemWithId: (options: { membership: any }) => this.translate('thankyouPage.myCartPaymentMethod.offlinePlan.lineItemWithId', options) /* Pay later with {{membership}} */,
            },
            onlinePlan: {
                lineItem: (options: { membership: any }) => this.translate('thankyouPage.myCartPaymentMethod.onlinePlan.lineItem', options) /* Pay with {{membership}} */,
            },
            deposit: {
                lineItem: (options: { price: any }) => this.translate('thankyouPage.myCartPaymentMethod.deposit.lineItem', options) /* Deposit: {{price}} */,
            },
            payWithPlan: {
                lineItem: () => this.translate('thankyouPage.myCartPaymentMethod.payWithPlan.lineItem') /* Pay with a plan */,
            },
        },
        menu: {
            upgradeTab: () => this.translate('thankyouPage.menu.upgradeTab') /* Upgrade */,
        },
        designTab: {
            backgroundPicker: () => this.translate('thankyouPage.designTab.backgroundPicker') /* Background opacity & color */,
            borderColor: () => this.translate('thankyouPage.designTab.borderColor') /* Border opacity & color */,
            borderWidth: () => this.translate('thankyouPage.designTab.borderWidth') /* Border width (px) */,
            dividers: () => this.translate('thankyouPage.designTab.dividers') /* Dividers */,
            border: () => this.translate('thankyouPage.designTab.border') /* Border */,
            titles: () => this.translate('thankyouPage.designTab.titles') /* Titles */,
            pageText: () => this.translate('thankyouPage.designTab.pageText') /* Body text */,
        },
        textTab: {
            pageSubtitle: () => this.translate('thankyouPage.textTab.pageSubtitle') /* Page subtitle */,
            titleTextLabel: () => this.translate('thankyouPage.textTab.titleTextLabel') /* Page title */,
            orderNumberLabel: () => this.translate('thankyouPage.textTab.orderNumberLabel') /* Order number label */,
            totalCostLabel: () => this.translate('thankyouPage.textTab.totalCostLabel') /* Total cost label */,
            continueShoppingPlaceholder: () => this.translate('thankyouPage.textTab.continueShoppingPlaceholder') /* Continue Browsing */,
            orderNumberDefaultText: () => this.translate('thankyouPage.textTab.orderNumberDefaultText') /* Order number: */,
            totalCostDefaultText: () => this.translate('thankyouPage.textTab.totalCostDefaultText') /* Total: */,
            shippingAddressLabel: () => this.translate('thankyouPage.textTab.shippingAddressLabel') /* Delivery address label */,
            subtitleDefaultText: () => this.translate('thankyouPage.textTab.subtitleDefaultText') /* You'll receive a confirmation email soon. */,
        },
    };
    public thank_you_page_plan_frequency_description_day_singular_label = () => this.translate('thank_you_page_plan_frequency_description_day_singular_label') /* per day */;
    public thank_you_page_plan_frequency_description_2_day_label = () => this.translate('thank_you_page_plan_frequency_description_2_day_label') /* every 2 days */;
    public thank_you_page_plan_frequency_description_days_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_days_plural_label', options) /* every {{numberOfFrequencyUnits}} days */;
}
/* tslint:enable */
